import { createContext } from 'react';
import type { SendBundleValidationResult, SendFdaValidatorRuleTexts } from '@/model/Agent.model';
import { fdaValidatorIdsOf } from './sendSeverity';

export type SendFdaRuleText = SendFdaValidatorRuleTexts['rules'][number];
export type SendFdaCredit = SendFdaValidatorRuleTexts['credit'];

/** The FDA's text for the validator rules a report cites, keyed by id, once fetched. */
export interface SendFdaRuleTextsValue {
  texts: ReadonlyMap<string, SendFdaRuleText>;
  credit?: SendFdaCredit;
}

export const SendFdaRuleTextsContext = createContext<SendFdaRuleTextsValue>({ texts: new Map() });

/** Whether any finding in a result, per file or across domains, cites an FDA validator rule. */
export const citesFdaValidatorRules = (result: SendBundleValidationResult): boolean =>
  result.per_domain.some((file) => file.findings.some((finding) => fdaValidatorIdsOf(finding).length > 0)) ||
  result.cross_domain.some((group) => group.findings.some((finding) => fdaValidatorIdsOf(finding).length > 0));

/** Indexes a fetched response by rule id. */
export const fdaRuleTextsOf = (response: SendFdaValidatorRuleTexts): SendFdaRuleTextsValue => ({
  texts: new Map(response.rules.map((rule) => [rule.id, rule])),
  credit: response.credit,
});
